/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import { FaFilter } from "react-icons/fa";

import { Helmet } from "react-helmet";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import getUsersCities from "../../Hooks/getUsersCities";
import { TOKEN_KEY } from "../../Utils/Constants";
import { baseUrl } from "../../shared/baseUrl";
import { createNotification } from "../Common/CreateNotification";
import useWindowDimensions from "../Common/Dimension/Dimension";
import ItemCard from "../Common/Item/ItemCard";
import LoadMore from "../Common/LoadMore";
import NoItems from "../Common/NoItems";
import SectionHead from "../Common/SectionHead";
import ShimmerCard from "../Common/Shimmer/ShimmerCard";
import "./Product.css";

const Products = (props) => {
  const { width } = useWindowDimensions();

  // const params = useParams();

  // console.log('Params ', params)

  const [pageOffset, setScrollPosition] = useState(0);
  const sideNavRef = useRef();
  const closeBtnRef = useRef();
  const openNavRef = useRef();
  const overlayRef = useRef();

  const [cityOption, setCityOption] = useState("");
  const [categoryOption, setCategoryOption] = useState("");

  const [forPagination, setForPagiation] = useState([]);
  const [products, setProducts] = useState([]);
  const [isFirstLoad, setIsFirstLoad] = useState(true);
  const [isSearchItemLoading, setIsSearchItemLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);

  const [search, setSearch] = useState(undefined);
  const [city, setCity] = useState(undefined);
  const [gender, setGender] = useState(undefined);
  const [category, setCategory] = useState(undefined);
  const [minPrice, setMinPrice] = useState(undefined);
  const [maxPrice, setMaxPrice] = useState(undefined);
  const [dateFrom, setDateFrom] = useState(undefined);
  const [dateTo, setDateTo] = useState(undefined);
  // const [metaImages, setMetaImages] = useState('');
  // const animatedComponents = makeAnimated();

  const handleScroll = () => {
    const position = window.pageYOffset;
    setScrollPosition(position);
  };

  useEffect(() => {
    const setCities = async () => {
      const userCities = await getUsersCities();
      setCityOption(userCities);
    };
    setCities();
    getCategories();
    if (width < 768) {
      let searchParams = new URLSearchParams(document.location.search).get(
        "search"
      );
      if (searchParams) setSearch(searchParams);
      getFilteredProducts();
    }
    window.addEventListener("scroll", handleScroll, { passive: true });

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (width > 768) {
      let searchParams = new URLSearchParams(document?.location?.search)?.get(
        "search"
      );
      if (searchParams) setSearch(searchParams);
      if (
        search !== undefined ||
        city !== undefined ||
        gender !== undefined ||
        category !== undefined ||
        isFirstLoad === true
      )
        handleSideNavClose();
      getFilteredProducts();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, city, gender, category]);

  useEffect(() => {
    let searchParams = new URLSearchParams(document?.location?.search)?.get(
      "search"
    );
    if (searchParams) setSearch(searchParams);
    // console.log(searchParams);
  }, [props]);

  useEffect(() => {
    overlayRef.current.addEventListener("click", (e) => {
      e.stopPropagation();
      handleSideNavClose();
    });

    openNavRef.current.addEventListener("click", (e) => {
      e.preventDefault();
      handleSideNavOpen();
    });
    closeBtnRef.current.addEventListener("click", (e) => {
      e.preventDefault();
      handleSideNavClose();
    });
  }, []);

  const handleSideNavOpen = () => {
    sideNavRef.current.style.transform = "translateX(0)";
    overlayRef.current.classList.add("sidebar-overlay");
  };

  const handleSideNavClose = () => {
    sideNavRef.current.style.transform = "translateX(-100%)";
    overlayRef.current.classList.remove("sidebar-overlay");
  };

  const resetFilter = (e) => {
    e.preventDefault();
    e.stopPropagation();
    Array.from(document.querySelectorAll("input")).forEach(
      (input) => (input.value = "")
    );
    Array.from(document.querySelectorAll("select")).forEach(
      (input) => (input.selectedIndex = 0)
    );

    setSearch(undefined);
    setCity(undefined);
    setGender(undefined);
    setCategory(undefined);
    setMinPrice(undefined);
    setMaxPrice(undefined);
    setDateFrom(undefined);
    setDateTo(undefined);
    getFilteredProducts();
    sessionStorage.setItem("selectedQuery", "");
    window.location.replace(`${window.location.origin}/products`);
  };

  const getFilteredProducts = () => {
    setIsFirstLoad(true);
    searchProduct(1, true);
  };

  const getCategories = async () => {
    await fetch(baseUrl + "all-categories")
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          var tempArr = [];

          res.data.forEach((res) => {
            tempArr.push({ value: res.id, label: res.category_name });
          });
          setCategoryOption([...tempArr]);
        } else {
          createNotification("error", res.message);
        }
      })
      .catch((e) => {
        createNotification("error", "Error in loading categories!");
      });
  };

  const searchProduct = async (page = 1, isFirstLoad) => {
    setIsSearchItemLoading(true);
    var requestBody = {};
    let searchParams = new URLSearchParams(document.location.search).get(
      "search"
    );

    if (searchParams) {
      requestBody.search = searchParams;
    }
    if (city !== undefined) requestBody.city = city;
    if (gender !== undefined) requestBody.gender = gender;
    if (category !== undefined) requestBody.category = category;
    if (minPrice !== undefined) requestBody.minprice = minPrice;
    if (maxPrice !== undefined) requestBody.maxprice = maxPrice;
    if (dateFrom !== undefined) requestBody.used_from = dateFrom;
    if (dateTo !== undefined) requestBody.used_to = dateTo;

    await fetch(baseUrl + `product-search?page=${page}&paginate=32`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        Authorization:
          localStorage.getItem(TOKEN_KEY) !== null
            ? "Bearer " + JSON.parse(localStorage.getItem(TOKEN_KEY)).token
            : null,
      },
      body: JSON.stringify(requestBody),
    })
      .then((res) => res.json())
      .then((res) => {
        setIsSearchItemLoading(false);
        if (res.success) {
          if (isFirstLoad) {
            setProducts(res.data.data);
          } else {
            setProducts((prevState) => [...prevState, ...res.data.data]);
          }
          setForPagiation(res.data);
          setIsFirstLoad(false);
        } else {
          createNotification("error", "Error in loading products!");
        }
      })
      .catch((e) => {
        setIsSearchItemLoading(false);
        createNotification("error", "Error in loading products!");
      });
  };

  const jsonLdData = {
    "@context": "http://schema.org",
    "@type": "Product",
    name: `Product`,
    description:
      "Products - Search for your best matching thrift item according to different category and criteria. Buy and sell preowned clothes and other accessories on Nepal's first digital thrift shop - Thrift Store Nepal (Thrift Shop Nepal)",
    url: "https://www.thriftstorenepal.com/",
    image: `${window.location.origin}/assets/images/og-2.png`,
    brand: {
      "@type": "Organization",
      name: "Thrift Store Nepal",
    },
  };

  return (
    <div className="mt-2 container">
      <Helmet>
        <title>{`Products - Thrift Store Nepal`}</title>
        <meta
          name="description"
          content="Products - Thrift Store Nepal - Search for your best matching thrift item according to different category and criteria. Buy and sell preowned clothes and other accessories on Nepal's first digital thrift shop - Thrift Store Nepal (Thrift Shop Nepal)"
        />
        <meta property="og:title" content="Products - Thrift Store Nepal" />
        <meta
          property="og:description"
          content="Products - Thrift Store Nepal - Buy and sell preowned clothes and other accessories on Nepal's first digital thrift shop - THrift Store Nepal (Thrift Shop Nepal)"
        />
        <meta name="og:image" content="/assets/images/og-2.png" />
      </Helmet>
      <script type="application/ld+json">{JSON.stringify(jsonLdData)}</script>
      <div className="d-flex mt-4">
        <h3 className="my-auto">Filter Items </h3>
        <SmBtn btn="danger" label="Reset" onClick={resetFilter} />
      </div>

      <FilterTemplate
        className1="col-12 col-sm-6 col-md-4 col-xl-2 p-2"
        className2="col-12 col-md-4 col-xl-2 p-2"
        className3="col-12 col-md-6 col-xl-3 p-2"
        gender={gender}
        setGender={setGender}
        city={city}
        cityOption={cityOption}
        setCity={setCity}
        category={category}
        categoryOption={categoryOption}
        setCategory={setCategory}
        getFilteredProducts={getFilteredProducts}
        minPrice={minPrice}
        setMinPrice={setMinPrice}
        maxPrice={maxPrice}
        setMaxPrice={setMaxPrice}
        dateFrom={dateFrom}
        setDateFrom={setDateFrom}
        dateTo={dateTo}
        setDateTo={setDateTo}
      />
      <div className="mt-4">
        <SectionHead leadFirstLabel="Recently" leadSecondLabel="Added" />
      </div>
      {pageOffset < 750 ? (
        <button
          ref={openNavRef}
          name="explore-cat-btn"
          className={`btn btn-primary btn-sm d-block d-lg-none mt-3`}
        >
          <FaFilter /> Filter
        </button>
      ) : (
        <button
          ref={openNavRef}
          name="explore-cat-btn"
          style={{ position: "fixed", bottom: 90, right: 30 }}
          className={`btn btn-primary btn-sm`}
        >
          <FaFilter /> Filter
        </button>
      )}

      <div className="d-flex flex-wrap">
        {/* {products && products.map((item, index) => {
                    return (
                        <ItemCard item={item} clsName="col-6 col-md-4 col-lg-3" index={index} />
                    );
                })} */}

        {isSearchItemLoading && isFirstLoad ? (
          <>
            {Array(7)
              .fill()
              .map((_, index) => {
                return (
                  <ShimmerCard
                    key={index}
                    clsName="col-6 col-md-4 col-lg-3"
                    index={index}
                  />
                );
              })}
          </>
        ) : products.length > 0 ? (
          <>
            {products.map((product, index) => {
              return (
                <ItemCard
                  item={product}
                  key={index}
                  clsName="col-6 col-md-4 col-lg-3 "
                  index={index}
                />
              );
            })}
            {isSearchItemLoading &&
              Array(10)
                .fill()
                .map((_, index) => {
                  return (
                    <ShimmerCard
                      key={index}
                      clsName="col-6 col-md-4 col-lg-3"
                      index={index}
                    />
                  );
                })}

            <LoadMore
              forPagination={forPagination}
              isLoading={isSearchItemLoading}
              onClick={() => {
                setCurrentPage(currentPage + 1);
                searchProduct(currentPage + 1);
              }}
            />
          </>
        ) : (
          <>
            <NoItems />
          </>
        )}
      </div>

      <div ref={sideNavRef} id="mySidenav" className="sidenav">
        <div className="d-flex flex-wrap justify-content-between px-3">
          <p className="fw-bold my-auto">Explore Categories</p>
          <div className="my-auto cursor-pointer" ref={closeBtnRef}>
            &times;
          </div>
        </div>
        <div className="bg-white w-100 p-3">
          <FilterTemplate
            gender={gender}
            setGender={setGender}
            city={city}
            cityOption={cityOption}
            setCity={setCity}
            category={category}
            categoryOption={categoryOption}
            setCategory={setCategory}
            getFilteredProducts={getFilteredProducts}
            minPrice={minPrice}
            setMinPrice={setMinPrice}
            maxPrice={maxPrice}
            setMaxPrice={setMaxPrice}
            dateFrom={dateFrom}
            setDateFrom={setDateFrom}
            dateTo={dateTo}
            setDateTo={setDateTo}
            divClass="d-flex"
          />
          <button
            onClick={() => {
              handleSideNavClose();
              getFilteredProducts();
            }}
            className="btn btn-primary d-flex d-lg-none"
          >
            Search
          </button>
        </div>
      </div>

      <div ref={overlayRef}></div>
    </div>
  );
};

export default Products;
const SmBtn = ({ onClick, label, btn }) => {
  return (
    <div
      onClick={onClick}
      style={{ fontSize: 10 }}
      className={`cursor-pointer ms-3 my-auto bg-${btn ?? "primary"
        } text-white px-2 py-1 rounded`}
    >
      {label}
    </div>
  );
};

const FilterTemplate = ({
  divClass = "d-none d-lg-flex",
  className1 = "col-12 mt-2",
  className2 = "col-12 mt-2",
  className3 = "col-12 mt-2",
  gender,
  setGender,
  city,
  cityOption,
  setCity,
  category,
  categoryOption,
  setCategory,
  getFilteredProducts,
  minPrice,
  setMinPrice,
  maxPrice,
  setMaxPrice,
  dateFrom,
  setDateFrom,
  dateTo,
  setDateTo,
}) => {
  const animatedComponents = makeAnimated();
  return (
    <div className={`bg-white ${divClass} flex-wrap col-12 my-3`}>
      <div className={`${className1}`}>
        <label className="form-label fw-bold">Gender</label>
        <select
          className="form-select"
          value={gender}
          onChange={(e) => {
            setGender(e.target.value);
          }}
        >
          <option value="m">Male</option>
          <option value="f">Female</option>
          <option value="b">Unisex</option>
        </select>
      </div>
      <div className={`${className1}`}>
        <label className="form-label fw-bold">City</label>
        {cityOption && (
          <Select
            // ref={selectBrandRef}
            className="react-option-select"
            autoComplete={false}
            closeMenuOnSelect={true}
            components={animatedComponents}
            placeholder={"Select City"}
            isMulti={false}
            options={cityOption}
            value={cityOption.find((u) => u.value === city) || ""} // set selected values
            onChange={(e) => {
              if (e !== null) {
                setCity(e.value);
              }
            }}
          />
        )}
      </div>
      <div className={`${className2}`}>
        <label className="form-label fw-bold">Category</label>
        {categoryOption && (
          <Select
            // ref={selectBrandRef}
            className="react-option-select"
            autoComplete={false}
            closeMenuOnSelect={true}
            components={animatedComponents}
            placeholder={"Select Cat"}
            isMulti={false}
            options={categoryOption}
            value={categoryOption.find((u) => u.value === category) || ""} // set selected values
            onChange={(e) => {
              if (e !== null) {
                setCategory(e.value);
              }
            }}
          />
        )}
      </div>
      <div className={`${className3}`}>
        <div className="d-flex mb-2">
          <label className="form-label fw-bold my-auto">Price Range</label>
          <SmBtn label="Search" onClick={getFilteredProducts} />
        </div>
        <div className="d-flex">
          <input
            type="number"
            min="1"
            className="form-control"
            placeholder="Rs. min"
            value={minPrice}
            onChange={(e) => {
              setMinPrice(e.target.value);
            }}
          />
          <p className="my-auto">&nbsp;&nbsp;&nbsp;to&nbsp;&nbsp;&nbsp;</p>
          <input
            type="number"
            className="form-control"
            placeholder="Rs. max"
            value={maxPrice}
            onChange={(e) => {
              setMaxPrice(e.target.value);
            }}
          />
        </div>
      </div>
      <div className={`${className3}`}>
        <div className="d-flex mb-2">
          <label className="form-label fw-bold my-auto">Used Date Range</label>
          <SmBtn label="Search" onClick={getFilteredProducts} />
        </div>
        <div className="d-flex">
          <input
            type="date"
            className="form-control"
            placeholder="Date From"
            value={dateFrom}
            onChange={(e) => {
              setDateFrom(e.target.value);
            }}
          />
          <p className="my-auto">&nbsp;&nbsp;&nbsp;to&nbsp;&nbsp;&nbsp;</p>

          <input
            type="date"
            className="form-control"
            placeholder="Date To"
            value={dateTo}
            onChange={(e) => {
              setDateTo(e.target.value);
            }}
          />
        </div>
      </div>
    </div>
  );
};
